import React, {useCallback, useState} from 'react';
import {Scrollbar, Input, Icon, PriorityIcon, Text} from '@priority-software/priority-style-react';
import {SearchableFieldItem} from './SearchableFieldItem';
import texts from '../../../../features/MoreInfo/texts';
import styles from './styles.module.scss';

type DataItem = {
    id: number;
    label: string;
};

type ListProps = {
    data: Array<DataItem>;
    selected: Array<DataItem>;
    limit?: number;
    addItem: (item: DataItem) => void;
    deleteItem: (id: number) => void;
};

export const SearchableFields = (props: ListProps) => {
    const {data, selected, limit, addItem, deleteItem} = props;
    const [inputValue, setInputValue] = useState('');

    const onChange = useCallback(e => setInputValue(e.target.value), [setInputValue]);
    const displayedFields = data.filter(field =>
        field.label.toLowerCase().includes(inputValue.toLowerCase())
    );

    const isSelected = id => {
        const isItemSelected = selected.findIndex(el => el.id === id);
        return isItemSelected > -1;
    };

    const isReachedLimit = selected.length >= limit;

    return (
        <div className={styles.component}>
            <Input
                componentClasses={styles.searchInput}
                placeholder={texts.search_placeholder}
                value={inputValue}
                onChange={onChange}
                autoFocus={true}
                roundedCorners
            >
                {inputValue ? (
                    <Icon icon={PriorityIcon.closeSmall} onClick={() => setInputValue('')} />
                ) : (
                    <Icon icon={PriorityIcon.searchThin} />
                )}
            </Input>

            {displayedFields.length === 0 ? (
                <Text tag="div" skin="paragraph-2">
                    {texts.no_result_msg}
                </Text>
            ) : (
                <Scrollbar autoHeight autoHeightMax={300} componentClasses={styles.scrollable}>
                    <div className={styles.list}>
                        {displayedFields.map(item => {
                            const isItemSelected = isSelected(item.id);

                            return (
                                <SearchableFieldItem
                                    item={item}
                                    isSelected={isItemSelected}
                                    isReachedLimit={isReachedLimit}
                                    inputValue={inputValue}
                                    addItem={addItem}
                                    deleteItem={deleteItem}
                                    selectedValues={selected}
                                    key={item.id}
                                />
                            );
                        })}
                    </div>
                </Scrollbar>
            )}
        </div>
    );
};
